import 'semantic-ui-style/semantic.min.css'
import './app.css'
import React, { lazy, useEffect, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { post } from './utils/apiClient'
import { useUser, useAccount } from './entities'

import Signin from './pages/signin.js'
import Home from './pages/home.js'
import Register from './pages/register.js'
import NoAuthView from './pages/view/no-auth-view.js'
import NoMatchPage from './pages/nomatch-page.js'

const Admin = lazy(() => import('./admin/Admin.js'))
const Account = lazy(() => import('./client/Account.js'))

export default function App() {
  const [userData, { updateUser }] = useUser()
  const [, { updateSettings }] = useAccount()

  const mount = () => {
    if (!userData.user) {
      // eslint-disable-next-line no-inner-declarations
      async function fetchData() {
        let res = await post('/api/session')
        if (res.settings) {
          updateUser(res.user && res.user.first_name ? res.user : null)
          updateSettings(res.settings)
          // } else if (res.errors) {
        } else {
          updateUser(undefined) // error loading, possibly try again?
        }
      }
      fetchData()
    }
  }
  useEffect(mount, [])
  console.log('>>>>userData:', userData)

  window.scrollTo(0, 0)
  if (userData.user?.admin_access === true) {
    return (
      <div className="app">
        <Suspense fallback={<div className="ui active centered loader"></div>}>
          <Routes>
            <Route path={`/`} element={<Home />} />
            <Route path={`/account/*`} element={<Account />} />
            <Route path={'/view/*'} element={<NoAuthView />} />
            <Route path={`/*`} element={<Admin />} />
          </Routes>
        </Suspense>
      </div>
    )
  } else if (userData.user) {
    return (
      <div className="app">
        <Suspense fallback={<div className="ui active centered loader"></div>}>
          <Routes>
            <Route path={`/`} element={<Home />} />
            <Route path={`/account/*`} element={<Account />} />
            <Route path={'/view/*'} element={<NoAuthView />} />
            <Route path={'/*'} element={<NoMatchPage />} />
          </Routes>
        </Suspense>
      </div>
    )
  } else if (userData.user === null) {
    return (
      <div className="noauth">
        <Suspense fallback={<div className="ui active centered loader"></div>}>
          <Routes>
            <Route exact path={'/register'} element={<Register />} />
            {/* <Route exact path={'/b/:uid?'} element={ClientBidView} /> */}
            <Route path={'/view/*'} element={<NoAuthView />} />
            <Route path={'/*'} element={<Signin />} />
          </Routes>
        </Suspense>
      </div>
    )
  } else if (userData === 'no_account') {
    return (
      <div className="noaccount noaccount mt-5 ui center aligned header"></div>
    ) // need error
  } else if (userData.user === undefined) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh'
        }}>
        <div>Error</div>
        <div>Please try reloading the page.</div>
      </div>
    )
  }

  return <div className="ui active centered loader"></div>
}
